"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowser = exports.between = exports.isNumber = exports.isFunction = void 0;
exports.isFunction = function (item) { return typeof item === 'function'; };
exports.isNumber = function (number) { return typeof number === 'number' && !isNaN(number); };
exports.between = function (number, min, max) { return number >= min && number < max; };
exports.isBrowser = function () { return typeof window !== "undefined"; };
//# sourceMappingURL=Utils.js.map